import React from "react";
import Container from "components/common/Container";
import { KLAVIYO_SIGN_UP_FORM_ID } from "constants/site";

const NewsletterForm = () => {
  return (
    <Container size="small">
      <div className={`klaviyo-form-${KLAVIYO_SIGN_UP_FORM_ID}`} />
    </Container>
  );
};

export default NewsletterForm;
